import { fmtDate } from "@/lib/format";

const pad = (n) => String(n).padStart(2, "0");
const us = (d) => `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;

export const presetRange = (key, now = new Date()) => {
  const y = now.getFullYear();
  const m = now.getMonth();
  if (key === "last-month") return [us(new Date(y, m - 1, 1)), us(new Date(y, m, 0))];
  if (key === "last-quarter") {
    const q = Math.floor(m / 3);
    return [us(new Date(y, (q - 1) * 3, 1)), us(new Date(y, q * 3, 0))];
  }
  return [us(new Date(y, 0, 1)), us(now)];
};

const PRESETS = [
  ["last-month", "Last Month"],
  ["last-quarter", "Last Quarter"],
  ["ytd", "Year-to-Date"],
];

export default function ReconRangePresets({ onPick, statements = [] }) {
  const withPeriod = statements.filter((s) => s.period_start && s.period_end);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="recon-range-presets">
      {PRESETS.map(([key, label]) => (
        <button
          key={key}
          type="button"
          onClick={() => onPick(...presetRange(key))}
          data-testid={`recon-preset-${key}`}
          className="text-xs px-2.5 py-1.5 border bg-white hover:bg-[var(--ll-mint)] transition-colors"
          style={{ borderColor: "var(--ll-border)" }}
        >
          {label}
        </button>
      ))}
      <select
        value=""
        onChange={(e) => {
          const s = withPeriod.find((x) => x.id === e.target.value);
          if (s) onPick(fmtDate(s.period_start), fmtDate(s.period_end));
        }}
        disabled={withPeriod.length === 0}
        data-testid="recon-statement-period-select"
        className="text-xs px-2 py-1.5 border bg-white max-w-[260px] disabled:opacity-50"
        style={{ borderColor: "var(--ll-border)" }}
        title={withPeriod.length ? "Fill dates from a statement's period" : "No statements with a detected period"}
      >
        <option value="">From statement…</option>
        {withPeriod.map((s) => (
          <option key={s.id} value={s.id}>
            {fmtDate(s.period_start)}–{fmtDate(s.period_end)} · {s.file_name}
          </option>
        ))}
      </select>
    </div>
  );
}
